export const inputEquipmentSerial = {
    bindings: {
        module: '@',
        identifier: '@'
    },
    template: require('./input-equipment-serial.html'),
    controller: 'InputEquipmentSerialController'
};
